import InvestStrategiesTable from './InvestStrategiesTable';

export default InvestStrategiesTable;
